module.exports = __webpack_public_path__ + "static/img/jimmy.d0c3849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/jimmy.png
// module id = n4QP
// module chunks = 1